module.exports = __webpack_public_path__ + "static/media/cases_3d_02f.f98a95af.jpg";